import { render, staticRenderFns } from "./OrdersAndMenu.vue?vue&type=template&id=2a0294b0&scoped=true&"
import script from "./OrdersAndMenu.vue?vue&type=script&lang=js&"
export * from "./OrdersAndMenu.vue?vue&type=script&lang=js&"
import style0 from "./OrdersAndMenu.vue?vue&type=style&index=0&id=2a0294b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0294b0",
  null
  
)

component.options.__file = "OrdersAndMenu.vue"
export default component.exports